import { useCompanyStore } from '@/stores/company';
import mixpanel from 'mixpanel-browser';

export default {
  install: (app: any, { token }: { token: string }) => {
    if (token) {
      mixpanel.init(token);
    }

    // Toggling this variable to prevent additional events being sent when the user double clicks
    let lastTrackedEvent: string | null = null;

    const mixpanelTracker = {
      track(event: string, variables: Record<string, unknown>) {
        if (!token || lastTrackedEvent === event || !event) {
          return;
        }

        const { settings } = useCompanyStore();
        if (!settings.booking_widget_mixpanel) {
          return;
        }

        mixpanel.track(event, variables);

        lastTrackedEvent = event;
        setTimeout(() => {
          lastTrackedEvent = null;
        }, 500);
      },
      register(data: any) {
        if (!token) {
          return;
        }

        mixpanel.register(data);
      },
      identify(id: string) {
        if (!token) {
          return;
        }

        mixpanel.identify(id);
      }
    };

    app.provide('mixpanel', mixpanelTracker);
  }
};
